import { t } from '@lingui/core/macro';
import { NumberRangeFilter } from './NumberRangeFilter';
export const paymentTermsDaysFilterLabel = () => t({
    message: 'Payment terms days from invoice date',
    comment: 'Insights: Payment terms days filter',
});
export function PaymentTermsDaysFilter() {
    return (<NumberRangeFilter name="metadataDocumentPaymentTermsDaysFromInvoiceDate" label={paymentTermsDaysFilterLabel()}/>);
}
